<section class="service-categories-page">

  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <div class="page-header">
    <h1>Service Categories</h1>
  </div>

  <!-- ── Filter bar ─────────────────────────────────────────────────────── -->
  <op-filter-bar
    searchPlaceholder="Search categories by name"
    [config]="filterConfig"
    [initialValues]="filterInitialValues()"
    [categoryOptions]="categoryOptions()"
    [cityOptions]="cityOptions()"
    [verticalOptions]="verticalOptions()"
    (filterChange)="onFilterChange($event)"
  />

  <!-- ── Table panel ────────────────────────────────────────────────────── -->
  <div class="table-panel">
    @if (loading()) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
    } @else if (error()) {
      <div class="empty error-text">{{ error() }}</div>
    } @else {
      <div class="table-wrap">
        @if (categories().length) {
          <table>
            <thead>
              <tr>
                <th>Category</th>
                <th>Vertical</th>
                <th>Active cities</th>
                <th>Inactive cities</th>
                <th class="num-th">Providers</th>
                <th>Example requests</th>
                <th>LLM description</th>
                <th>Status</th>
                <th>Created</th>
                <th class="actions-th"></th>
              </tr>
            </thead>
            <tbody>
              @for (cat of categories(); track cat.category_id) {
                <tr>

                  <!-- Category name -->
                  <td class="name-cell">
                    <div class="cell-stack">
                      <span class="cat-name">{{ cat.name }}</span>
                      <span class="cat-id">{{ cat.category_id }}</span>
                    </div>
                  </td>

                  <!-- Vertical -->
                  <td class="vertical-cell">
                    <span class="vertical-chip vertical-chip--{{ cat.vertical }}">
                      {{ verticalLabel(cat.vertical) }}
                    </span>
                  </td>

                  <!-- Active cities -->
                  <td class="cities-cell">
                    <div class="cell-stack">
                      <span class="cities-text">{{ cityAvailabilitySummary(cat) }}</span>
                      @if (totalCityCount(cat) > 0) {
                        <span class="cities-count">{{ activeCityCount(cat) }}/{{ totalCityCount(cat) }} active</span>
                      }
                    </div>
                  </td>

                  <!-- Inactive cities -->
                  <td class="cities-cell">
                    @if (inactiveCityCount(cat) > 0) {
                      <div class="cell-stack">
                        <span class="cities-text cities-text--inactive">{{ inactiveCitySummary(cat) }}</span>
                        <span class="cities-count">{{ inactiveCityCount(cat) }} off</span>
                      </div>
                    } @else {
                      <span class="cities-text cities-text--none">—</span>
                    }
                  </td>

                  <!-- Provider count -->
                  <td class="num-cell">
                    <span class="num-badge" [class.num-badge--zero]="cat.provider_count === 0">
                      {{ cat.provider_count }}
                    </span>
                  </td>

                  <!-- Example requests -->
                  <td class="examples-cell">
                    <span class="muted-text">{{ exampleRequestsSummary(cat) }}</span>
                  </td>

                  <!-- LLM description (truncated) -->
                  <td class="desc-cell">
                    <span class="muted-text" [title]="cat.description_ai">{{ truncateDescription(cat.description_ai) }}</span>
                  </td>

                  <!-- is_active status -->
                  <td class="status-cell">
                    @if (cat.is_active) {
                      <span class="status-chip status-chip--active">Active</span>
                    } @else {
                      <span class="status-chip status-chip--inactive">Inactive</span>
                    }
                  </td>

                  <!-- Created at -->
                  <td class="date-cell">{{ formatDate(cat.created_at) }}</td>

                  <!-- Actions -->
                  <td class="actions-cell">
                    <a class="ghost-btn ghost-btn--small" [routerLink]="['/service-categories', cat.category_id]">Open</a>
                  </td>

                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty">No service categories found.</div>
        }
      </div>
    }
  </div>

</section>